import React from 'react';
import styles from '@/styles/components/Footer.module.css';

const Footer: React.FC = () => (
  <footer className={styles.footer}>
    <a href="#" className={styles.link}>Data Policy</a>
    <div className={styles.divider} />
    <a href="#" className={styles.link}>User Agreement</a>
  </footer>
);

export default Footer; 